"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _token = require("./../_utils/token");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// All of the complicated CSS here is required in order to make the characters
// in the placeholder (e.g. Y, M, D, -, and separators) line up with the numeric
// characters in the user's input, which do not have the same character widths.
var placeholderStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var disabled = _ref.disabled;
  return (0, _emotion.css)({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    // HACK: We only accept dates in English numerals for now - since we don't yet
    // support other locale numerals, eg: ١،٢،٣،٤،٥،٦،٨،٩،٠ 一，二，三，四，五, etc.
    // Dates entered in English numerals are read and typed LTR.
    direction: "ltr !important",
    textAlign: "left !important",
    pointerEvents: "none",
    color: t("inputPlaceholderColor", disabled ? "disabled" : "default"),
    whiteSpace: "pre",
    // Apply the same letter spacing that the input has to the inline blocks
    // that hold each placeholder character
    "& > * + *": {
      marginLeft: t("inputValueLetterSpacing")
    }
  });
}, ["disabled"]);
var placeholderCharStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var placeholderChar = _ref2.placeholderChar,
      empty = _ref2.empty,
      separator = _ref2.separator,
      actualChar = _ref2.actualChar;
  return (0, _emotion.css)({
    position: "relative",
    display: "inline-block",
    // This pseudo element reserves an approximate amount of space for the
    // placeholder character that an actual character in the input would take
    // up. It does this by using for its contents the actual character (if
    // filled) or a "0" when it is placeholding for empty characters (all digit
    // chars are the same width) or an identical separator char (e.g. a ":"
    // for US times) when it lines up with one of those. This ensures that the
    // placeholder characters line up fully with the input characters, even
    // if they have different character widths.
    "&:before": {
      color: "transparent",
      content: separator ? "'".concat(placeholderChar, "'") : empty ? "'0'" : "'".concat(actualChar, "'")
    }
  }, // For non-separator characters use the after psuedo element to show a shrunk-
  // down  version of the character exactly centered in the character box where
  // the corresponding input char would be rendered. This allows a placeholder
  // character that is much wider than a digit (e.g. the "M") to still line
  // up with the digit.
  separator ? undefined : {
    "&:after": {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translateY(-50%) translateX(-50%)",
      opacity: empty ? 1 : 0,
      content: "'".concat(placeholderChar, "'"),
      fontSize: t("inputPlaceholderFontSize"),
      lineHeight: t("inputPlaceholderLineHeight")
    }
  });
}, ["placeholderChar", "empty", "separator", "actualChar"]);

var InputMonospacePlaceholder = function InputMonospacePlaceholder(props) {
  var t = props.t,
      mask = props.mask,
      disabled = props.disabled,
      value = props.value; // If given a display format (like "YYYY/MM/DD") via props, use that.
  // Otherwise, construct from the mask replacing all non-literals with "–"

  var displayFormat = (0, _react.useMemo)(function () {
    return props.displayFormat || mask.mask.replace(/[#*]/gi, "–");
  }, [mask, props.displayFormat]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: placeholderStyles(t, {
      disabled: disabled
    }),
    "aria-hidden": "true"
  }, displayFormat.split("").map(function (_, index) {
    var placeholderChar = displayFormat[index];
    var empty = !value[index] || value[index] === mask.placeholderChar;
    var separator = !mask.formatChars[mask.mask[index]];
    var actualChar = value[index];
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: placeholderCharStyles(t, {
        placeholderChar: placeholderChar,
        empty: empty,
        separator: separator,
        actualChar: actualChar
      })
    });
  }));
};

InputMonospacePlaceholder.propTypes = process.env.NODE_ENV !== "production" ? {
  mask: _propTypes["default"].object.isRequired,

  /**
   * Tokens should have the following keys (values can obviously vary)
   * input: {
   *   valueLetterSpacing: "2px",
   *   placeholder: {
   *     fontSize: "13px",
   *     lineHeight: "18px",
   *     color: {
   *       default: "theme-foreground-secondary-default",
   *       disabled: "theme-foreground-primary-disabled",
   *     },
   *   },
   * }
   **/
  t: _propTypes["default"].func.isRequired,
  value: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  displayFormat: _propTypes["default"].string
} : {};
var _default = InputMonospacePlaceholder;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/_input-monospace-placeholder/input-monospace-placeholder.js
// module id = 869
// module chunks = 0